import SimilarProductsSection from './SimilarProductsSection';
export default SimilarProductsSection;
